import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiGatewayService, authenticationSelectors } from '@wam/authentication';
import { INotification, State, User } from '@wam/shared';
import { select, Store } from '@ngrx/store';
import { map, mergeMap, take } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class MessagesAndNotificationsService {
  private apiGatewayService = inject(ApiGatewayService);
  private store = inject<Store<State>>(Store);

  loadNotifications(): Observable<INotification[]> {
    return this.withUser().pipe(
      mergeMap(({ application, uuid, sub }) =>
        this.apiGatewayService.simpleGet<{ results: INotification[] }>(
          `feed/v4/apps/${application}/groups/notification/feeds/${
            uuid ?? sub
          }/activities?limit=100`,
        ),
      ),
      map(({ results }) => results),
      take(1),
    );
  }

  markAsRead(notification: INotification): Observable<INotification> {
    return this.withUser().pipe(
      mergeMap(({ application, uuid, sub }) =>
        this.apiGatewayService.simplePatch<INotification>(
          `feed/v4/apps/${application}/groups/notification/feeds/${uuid ?? sub}/activities/${
            notification.id
          }`,
          { read: true },
        ),
      ),
      take(1),
    );
  }

  private withUser(): Observable<User> {
    return this.store.pipe(select(authenticationSelectors.getCurrentUser));
  }
}
